/* eslint-disable import/no-unresolved */
const constants = require('onestic-base/constants');
const slickSlider = require('onestic-base/components/slider');
const utils = require('onestic-base/utils');

/**
 * Gets Slot Title from Slot Callout field after slick slider is up and running
 */
const getSlotTitle = () => {
    const featuredCarousel = $('.featured-product-carousel');
    if (featuredCarousel.length) {
        const slotTitles = $('.featured-product-carousel > .featured-carousel-container').find('.callout-slot');
        slotTitles.each((index, node) => {
            const slotTitle = $(node);
            const slotTitleValue = slotTitle.attr('value');
            slotTitle.parents('.featured-product-carousel').find('> .text-block > span').text(slotTitleValue);
        });
    }
};

/**
 * Hide product carousel container if empty
 */
const hideEmptyProductCarousels = () => {
    const productCarousels = $('.featured-product-carousel');
    productCarousels.each((index, carousel) => {
        const $carousel = $(carousel);
        if ($carousel.find('.item').length <= 0) {
            $carousel.addClass('d-none');
        }
    });
};

// eslint-disable-next-line consistent-return
const checkElement = (selector, fn) => {
    if ($(selector).length) {
        fn();
        return;
    }
    setTimeout(() => {
        checkElement(selector, fn);
    }, 200);
};

const slotTitle = () => {
    checkElement('.featured-product-carousel > .text-block > span', getSlotTitle);
};

/**
 * Runs Slick Slider on product carousel
 * @param {jQuery} element carousel for slick slider.
 */
const runSlick = (element) => {
    const { prev, next } = utils.getSliderLabels();
    setTimeout(() => {
        slickSlider.methods.useCustomizableSlick(
            element,
            true,
            `<button type="button" class="icon-left-arrow-line next no-btn" aria-label="${prev}"></button>`,
            `<button type="button" class="icon-right-arrow-line prev no-btn" aria-label="${next}"></button>`,
            4,
            {
                arrows: true,
                infinite: false,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: constants.viewport_bootstrap.md,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            arrows: true,
                        },
                    },
                    {
                        breakpoint: constants.viewport_bootstrap.lg,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            arrows: true,
                        },
                    },
                ],
            },
        );

        slotTitle();
        hideEmptyProductCarousels();
    }, 1000);
};

const slickConfig = () => {
    checkElement('.product-carousel .product', runSlick.bind(null, '.product-carousel'));
};

module.exports = () => {
    slickConfig();
};
